import React, { useMemo } from 'react';
import TableContainer from '../../../Components/Common/TableContainer';
import { mockOrders } from '../data/mockData';
import TableContainerReactTable from 'Components/Common/TableContainerReactTable';

const OrderTable: React.FC = () => {
  const columns = useMemo(
    () => [
      {
        header: "Order Id",
        cell: (cell: any) => {
          return (
            <div className="text-left">
              {cell.getValue()}
            </div>
          );
        },
        accessorKey: "orderId",
        enableColumnFilter: false,
      },
      {
        header: "Order Date",
        accessorKey: "orderDate",
        enableColumnFilter: false,
      },
      {
        header: "Type",
        accessorKey: "type",
        enableColumnFilter: false,
      },
      {
        header: "First Name",
        accessorKey: "firstName",
        enableColumnFilter: false,
      },
      {
        header: "Last Name",
        accessorKey: "lastName",
        enableColumnFilter: false,
      },
      {
        header: "Account",
        accessorKey: "account",
        enableColumnFilter: false,
      },
      {
        header: "Status",
        enableColumnFilter: false,
        accessorKey: "status",
        cell: (cell: any) => {
          const status = cell.getValue();
          return (
            <span className={`badge ${
              status === 'Printed' ? 'bg-success-subtle text-success' :
              status === 'Pending' ? 'bg-warning-subtle text-warning' :
              'bg-danger-subtle text-danger'
            } text-uppercase`}>
              {status}
            </span>
          );
        },
      },
      {
        header: "Location",
        accessorKey: "location",
        enableColumnFilter: false,
      },
      {
        header: "PO Number",
        accessorKey: "poNumber",
        enableColumnFilter: false,
      },
      {
        header: "Owner",
        accessorKey: "owner",
        enableColumnFilter: false,
      },
      {
        header: "Priority",
        accessorKey: "priority",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const priority = cell.getValue();
          return (
            <span className={`badge ${
              priority === 'High' ? 'bg-danger-subtle text-danger' :
              priority === 'Medium' ? 'bg-warning-subtle text-warning' :
              'bg-success-subtle text-success'
            } text-uppercase`}>
              {priority}
            </span>
          );
        },
      },
      {
        header: "Internal Note",
        accessorKey: "internalNote",
        enableColumnFilter: false,
      },
      {
        header: "Total",
        accessorKey: "total",
        enableColumnFilter: false,
        cell: (cell: any) => {
          return `$${cell.getValue().toFixed(2)}`;
        },
      },
      {
        header: "Delivery Date",
        accessorKey: "deliveryDate",
        enableColumnFilter: false,
      }
    ],
    []
  );

  return (
    <React.Fragment>
      <TableContainerReactTable
        columns={columns}
        data={mockOrders}
        isGlobalFilter={false}
        customPageSize={10}
        tableClass="table-centered align-middle table-nowrap table-sm mb-0"
        theadClass="table-light"
        divClass="table-responsive"
      />
    </React.Fragment>
  );
};

export default OrderTable; 